import React, { useContext } from 'react';
import classNames from 'classnames';
import ResolveHeader from 'components/ResolveHeader';
import { SmallFooter } from 'components/SmallFooter';
import EnterpriseHeader from 'router/subrouters/Dash/subrouters/private/subrouters/Enterprise/components/EnterpriseHeader';
import { Outlet } from 'react-router-dom';
import EnterpriseProvider from './providers/Enterprise/Enterprise.provider';
import EnterpriseContext from './providers/Enterprise/Enterprise.context';
import RwcEnterpriseNavigation from './components/RwcEnterpriseNavigation';

import './RwcAnalytics.styles.scss';
import './RwcAnalytics.styles.responsive.scss';

const EnterpriseWrapper: React.FC = () => {
  const { enterprise } = useContext(EnterpriseContext);

  return (
    <>
      <EnterpriseHeader enterprise={enterprise} />
      <RwcEnterpriseNavigation />
      <Outlet />
    </>
  );
};

type RwcAnalyticsProps = {
  className?: string;
};

const RwcAnalytics: React.FC<RwcAnalyticsProps> = (props) => {
  const { className } = props;

  const classes = classNames('rwc-analytics', className);

  return (
    <EnterpriseProvider>
      <div className={classes}>
        <ResolveHeader />

        <main>
          <EnterpriseWrapper />
        </main>

        <SmallFooter />
      </div>
    </EnterpriseProvider>
  );
};

export default RwcAnalytics;
